<template>
    <div :class="`send-btn-container-${localAlign}`">
        <button id="container" class="send-btn" @click="sendForm">
            <div class="btn-content">
                <span class="btn-text">{{ displayLabel }}</span>
                <div class="btn-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="22" y1="2" x2="11" y2="13"/>
                        <polygon points="22,2 15,22 11,13 2,9"/>
                    </svg>
                </div>
            </div>
        </button>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "FormSend",
    props: {
        label: String,
        align: String,
        item: Object,
    },
    data() {
        return {
            localLabel: this.label || "Gönder",
            localAlign: this.align || "top",
            updateTimer: null,
        };
    },
    computed: {
        displayLabel() {
            return this.localLabel || "Gönder";
        },
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        sendForm() {
            console.log('Form gönderiliyor...');
            // Form submit logic burada olacak
        },
        updateField() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
                const updateFields = {
                    label: self.localLabel,
                    send: {
                        fieldLabel: self.localLabel,
                        align: self.localAlign,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                });
                self.$emit("update-field", updateFields);
            }, 200);
        },
    },
    watch: {
        label(newVal) {
            this.localLabel = newVal;
            this.updateField();
        },
        align(newVal) {
            this.localAlign = newVal;
            this.updateField();
        },
    },
    mounted() {
        this.localLabel = this.label || "Gönder";
        this.localAlign = this.align || "top";
    },
};
</script>

<style lang="scss" scoped>
// Container alignment sistemleri
.send-btn-container-left {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    max-width: 700px;
    margin: clamp(1.5rem, 3vw, 2rem) auto;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.send-btn-container-right {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    max-width: 700px;
    margin: clamp(1.5rem, 3vw, 2rem) auto;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.send-btn-container-top {
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 700px;
    margin: clamp(2rem, 4vw, 2.5rem) auto;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

// Modern send button
.send-btn {
    position: relative;
    padding: clamp(1rem, 2.5vw, 1.25rem) clamp(2rem, 4vw, 2.5rem);
    font-size: clamp(0.9rem, 2vw, 1rem);
    font-weight: 600;
    color: white;
    background: linear-gradient(135deg, #f26a52 0%, #e55a42 100%);
    border: none;
    border-radius: clamp(0.75rem, 1.5vw, 1rem);
    cursor: pointer;
    outline: none;
    overflow: hidden;
    transition: all 0.3s ease;
    min-width: clamp(10rem, 20vw, 12rem);
    backdrop-filter: blur(8px);
    box-shadow: 0 8px 32px rgba(242, 106, 82, 0.3),
                0 2px 8px rgba(0, 0, 0, 0.1);
    
    .btn-content {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: clamp(0.75rem, 1.5vw, 1rem);
        z-index: 2;
        
        .btn-text {
            font-family: inherit;
            letter-spacing: 0.5px;
            transition: all 0.3s ease;
        }
        
        .btn-icon {
            width: clamp(1.25rem, 2.5vw, 1.5rem);
            height: clamp(1.25rem, 2.5vw, 1.5rem);
            transition: all 0.3s ease;
            
            svg {
                width: 100%;
                height: 100%;
            }
        }
    }
    
    &:hover {
        transform: translateY(-2px);
        background: linear-gradient(135deg, #e55a42 0%, #d44a32 100%);
        box-shadow: 0 12px 48px rgba(242, 106, 82, 0.4),
                    0 4px 16px rgba(0, 0, 0, 0.15);
        
        .btn-content {
            .btn-text {
                transform: translateX(-2px);
            }
            
            .btn-icon {
                transform: translateX(4px) rotate(15deg);
            }
        }
    }
    
    &:active {
        transform: translateY(0px);
        box-shadow: 0 4px 16px rgba(242, 106, 82, 0.3),
                    0 1px 4px rgba(0, 0, 0, 0.1);
    }
    
    &:focus-visible {
        outline: 3px solid rgba(242, 106, 82, 0.3);
        outline-offset: 2px;
    }
}

@media (max-width: 768px) {
    .send-btn-container-left,
    .send-btn-container-right {
        justify-content: center;
        margin: clamp(1.25rem, 2.5vw, 1.5rem) auto;
    }

    .send-btn {
        padding: clamp(0.875rem, 2vw, 1rem) clamp(1.75rem, 3.5vw, 2rem);
        font-size: clamp(0.875rem, 1.8vw, 0.9rem);
        min-width: clamp(8rem, 16vw, 10rem);
        border-radius: clamp(0.625rem, 1.2vw, 0.75rem);
        
        .btn-content {
            gap: clamp(0.625rem, 1.2vw, 0.75rem);
            
            .btn-icon {
                width: clamp(1.125rem, 2.2vw, 1.25rem);
                height: clamp(1.125rem, 2.2vw, 1.25rem);
            }
        }
    }
}

@media (prefers-reduced-motion: reduce) {
    .send-btn {
        transition: none;
        
        .btn-content,
        .btn-icon,
        .btn-text {
            transition: none;
        }

        &:hover {
            transform: none;
        }
        
        &:active {
            transform: none;
        }
    }
}
</style>